import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function LoadingSkeleton({ style }) {
  return (
    <div>
      <Skeleton style={style} />
    </div>
  );
}
